<template>
    <v-col cols="12" class="ProfileAdministrator mt-0 pt-0">
        <v-row
                align="stretch"
                justify="space-around"
                class="pa-4 pt-0"
                style="height: 100%"
        >
            <v-col cols="12" >
                <v-card
                        class="pa-4 elevation-0"
                        tile
                        height="100%"
                >
                    <h2 class="font-weight-medium">Mi Perfil - <span class="blue--text">Nombre Apellido</span></h2>
                    <v-col cols="6" >
                        <v-row>
                            <v-col cols="4">
                                <v-card
                                        class="pa-2 ma-0 elevation-1"
                                        tile
                                        height="150px"
                                        width="150px"
                                >
                                    <v-img src="@/assets/images/perfil.png"
                                           height="140px"
                                           width="140px"
                                           aspect-ratio="2"
                                           contain>
                                    </v-img>
                                </v-card>
                            </v-col>
                            <v-col cols="8" class="pt-12">
                                <v-text-field
                                        label="Rut de la Empresa"
                                        placeholder="00.000.000-0"
                                        dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="">
                            <v-col class="pa-0" cols="4">
                                <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 31px; ">Nombre de Fantasía</v-subheader>
                            </v-col>
                            <v-col class="pa-0" cols="8">
                                <v-text-field
                                        placeholder="Nombre Completo de la Empresa S.A."
                                        dense

                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="">
                            <v-col class="pa-0" cols="4">
                                <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 31px; ">Razon Social</v-subheader>
                            </v-col>
                            <v-col class="pa-0" cols="8">
                                <v-text-field
                                        placeholder="Razon Social Empresa"
                                        dense

                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="">
                            <v-col class="pa-0" cols="4">
                                <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 31px; ">Giro Comercial</v-subheader>
                            </v-col>
                            <v-col class="pa-0" cols="8">
                                <v-text-field
                                        placeholder="Giro Empresa"
                                        dense

                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="">
                            <v-col class="pa-0" cols="4">
                                <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 31px; ">Direccion Comercial
                                </v-subheader>
                            </v-col>
                            <v-col class="pa-0" cols="8">
                                <v-text-field
                                        placeholder="Calle #000, Comuna, Region, Pais"
                                        dense

                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="">
                            <v-col class="pa-0" cols="4">
                                <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 31px; ">Representante Legal</v-subheader>
                            </v-col>
                            <v-col class="pa-0" cols="8">
                                <v-text-field
                                        placeholder="Nombre Apellido"
                                        dense
                                        @click="dialog.show = true"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="">
                            <v-col class="pa-0" cols="4">
                                <v-subheader class="font-weight-bold caption px-3 border-bottom-1 " style="height: 31px; ">Correo Electronico</v-subheader>
                            </v-col>
                            <v-col class="pa-0" cols="8">
                                <v-text-field
                                        placeholder="info@neocity.cl"
                                        dense

                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mb-5">
                            <v-col class="pa-0" cols="4">
                                <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 31px; ">Sitio Web</v-subheader>
                            </v-col>
                            <v-col class="pa-0" cols="8">
                                <v-text-field
                                        placeholder="www.neocity.cl"
                                        dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-btn color="primary"
                               raised
                               dark
                               @click="dialog.sendData.show = true"
                               class="pa-6">Actualizar Datos</v-btn>
                    </v-col>


                </v-card>
            </v-col>
        </v-row>

        <v-dialog
            v-model="dialog.show"
            width="70%"
        >
            <v-card class="pt-2 pa-8">
                <v-card-title class="headline mx-auto justify-center">
                    Validar Representante Legal
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="8" class="mx-auto text-center">
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam fringilla lacus vel porta vestibulum. Pellentesque varius, arcu vitae ornare posuere, ligula nulla interdum dolor</p>
                        </v-col>
                        <v-col cols="12" class="text-center">
                            <v-file-input label="Seleccionar archivo PDF" outlined dense></v-file-input>
                            <p class="caption">El archivo no debe superar los 10mb</p>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions class="justify-center">
                    <v-btn
                            color="primary"
                            raised
                            outlined
                            class="px-6"
                            @click="dialog.show = false"
                    >
                        Ver mas Tarde
                    </v-btn>
                    <v-btn
                            color="primary"
                            raised
                            dark
                            @click="dialog.show = false"
                    >
                        Cargar El Documento
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialog.sendData.show"
                width="70%"
        >
            <v-card class="pt-2 pa-8">
                <v-card-title class="headline mx-auto justify-center">
                    Tu información ha sido enviada
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="8" class="mx-auto text-center">
                            <p>Hemos enviado toda tu infomacion al equipo de validación. Revisaremos tu información esté correcta y te enviaremos el link para que puedas completar tu registro y comenzar a ofertar enería</p>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn
                            color="primary"
                            raised
                            dark
                            @click="dialog.sendData.show = false"
                    >
                        Volver al Inicio
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


    </v-col>

</template>
<script>
    export default {
        name: 'ProfileAdministrator',
        data() {
            return {
                dialog: {
                    show: false,
                    sendData:{ show:false }
                }

            }
        },
        created: function () {
            this.$emit('SetcolorMenu', 'primary');
        }
    }
</script>